import { Filter } from '@anytag/shared-molecules';
import { useDouyinInfluencersContext } from '../DouyinInfluencersContext';
import { BasicFilter } from './BasicFilter';

export const DouyinInfluencersFilter = () => {
  const { filter, setFilter, isEngagementPage, isPackagePage } = useDouyinInfluencersContext();

  return (
    <Filter.Provider onSubmit={setFilter} values={filter} className="rounded-none">
      <BasicFilter isEngagementPage={isEngagementPage} isPackagePage={isPackagePage} />
    </Filter.Provider>
  );
};
